import { Provider } from "components/religion/ReligionContext";
import { ReligionList } from "components/religion/ReligionList";
import React from "react";

export const Religions = () => {
    return (
        <Provider>
            <ReligionList />
        </Provider>
    );
};
